import Carousel from 'react-material-ui-carousel'
import { Stack, Typography } from '@mui/material'
import { getCurrentMode } from '../../store/redux/reducers/darkModeSlice'
import { useSelector } from 'react-redux'
import { t } from 'i18next'
import { environment } from '../../enviroments/enviroment'

const TIME_LIGHT = `${environment.publicUrl}/assets/image/illustrations/time-management-light-mode.svg`
const TIME_DARK = `${environment.publicUrl}/assets/image/illustrations/time-management-dark-mode.svg`

const TEAMS_LIGHT = `${environment.publicUrl}/assets/image/illustrations/manage-teams-light-mode.svg`
const TEAMS_DARK = `${environment.publicUrl}/assets/image/illustrations/manage-teams-dark-mode.svg`

const PROJECTS_LIGHT = `${environment.publicUrl}/assets/image/illustrations/manage-projects-light-mode.svg`
const PROJECTS_DARK = `${environment.publicUrl}/assets/image/illustrations/manage-projects-dark-mode.svg`

const REPORTS_LIGHT = `${environment.publicUrl}/assets/image/illustrations/reports-light-mode.svg`
const REPORTS_DARK = `${environment.publicUrl}/assets/image/illustrations/reports-dark-mode.svg`

type Slide = {
  imageLight: string
  imageDark: string
  key: string
}

const slides: Slide[] = [
  {
    imageLight: TIME_LIGHT,
    imageDark: TIME_DARK,
    key: 'timeManagement',
  },
  {
    imageLight: TEAMS_LIGHT,
    imageDark: TEAMS_DARK,
    key: 'teamsManagement',
  },
  {
    imageLight: PROJECTS_LIGHT,
    imageDark: PROJECTS_DARK,
    key: 'projectsManagement',
  },
  {
    imageLight: REPORTS_LIGHT,
    imageDark: REPORTS_DARK,
    key: 'reports',
  },
]

const LoginCarousel = () => {
  return (
    <Stack
      width="100%"
      height="100%"
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ bgcolor: 'background.elevation1' }}
      borderRadius={4}
      px="10%"
    >
      <Carousel
        fullHeightHover={false}
        navButtonsAlwaysVisible={true}
        navButtonsProps={{
          style: {
            pointerEvents: 'auto',
          },
        }}
        navButtonsWrapperProps={{
          style: {
            pointerEvents: 'none',
          },
        }}
        indicatorContainerProps={{
          style: {
            marginTop: 24,
          },
        }}
        changeOnFirstRender={false}
        animation="slide"
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {slides.map((s, i) => (
          <CarouselItem key={s.key} slide={s} />
        ))}
      </Carousel>
    </Stack>
  )
}

type CarouselItemProps = {
  slide: Slide
}

const CarouselItem = ({ slide }: CarouselItemProps) => {
  const mode = useSelector(getCurrentMode)
  return (
    <Stack width="100%" height="500px" direction="column" alignItems="center" justifyContent="center" gap={6}>
      <Stack
        width={{ lg: '400px', md: '300px', sm: '200px' }}
        height={{ lg: '400px', md: '300px', sm: '200px' }}
        justifyContent="center"
        alignItems="center"
      >
        <img
          style={{
            width: '100%',
            height: '100%',
            WebkitBackfaceVisibility: 'hidden',
          }}
          src={mode === 'light' ? slide.imageLight : slide.imageDark}
          alt="carousel"
        />
      </Stack>
      <Stack direction="column" alignItems="center" justifyContent="center" gap={1}>
        <Typography variant="h4" component="h2" sx={{ color: 'text.lighter', textAlign: 'center' }}>
          {t(`page.login.carousel.${slide.key}.title`)}
        </Typography>
        <Typography sx={{ width: '65%', textAlign: 'center' }}>
          {t(`page.login.carousel.${slide.key}.description`)}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default LoginCarousel
